// loader.js
import main from "./main";
import billboards from "./billboards";
let store = {
  main,
  billboards,
};

const warnSameReducerExists = (storeModuleName, name) => {
    if (!name) return;
    console.error(
      `store error: ${storeModuleName} ${name} reducer is already set. Check that ${name} are not reseved by other store reducers`,
    );
  };
  
  const warnSameActionExists = ( storeModuleName, name ) => {
    if (!name) return;
  
    console.error(
      `store error: ${storeModuleName} ${name} action is already set. Check that ${name} are not reseved by other store actions`,
    );
  };
  
  const checkUniquness = (a, b) => {
    return Object.keys(b).find((e) => a[e] !== undefined);
  };
  
  /**
   * reducers - object containing all reducers, the reducers name should be unique
   * actions - object containing all actions to trigger reducers changes, names should be unique
   */
  export const modules = Object.keys(store).reduce(
    (result, key) => {
      let storeModule = store[key];
  
      warnSameReducerExists(
        key,
        checkUniquness(result.reducers, storeModule.reducers),
      );
      result.reducers = Object.assign(result.reducers, storeModule.reducers);
  
      warnSameActionExists(
        key,
        checkUniquness(result.actions, storeModule.actions),
      );
      result.actions = Object.assign(result.actions, storeModule.actions);
  
      return result;
    },
    {
      reducers: {},
      actions: {},
    },
  );
  



// WEBPACK FOOTER //
// ./src/store/loader.js